import toastTrigger from '@ui/toast/toast-trigger';
import { EToastTypes } from '@ui/toast/toast.types';

export const cannotDeleteToast = (errorMessage: string) =>
  toastTrigger('Could not delete', {
    type: EToastTypes.error,
    autoClose: 10000,
    description: `The following content must be removed from all projects before being deleted: ${errorMessage}`,
  });
